/**
 * The phone pages' website slots: Sign in with Telegram and the chat card's line and door
 * (shared-client-screens rows S1, S2, E1, E2); the website's Back is the page mover's `useSiteBack`.
 * The frame itself is the app's SessionDetailFrame, inside the shared detail screens.
 */
import { useTelegramSignIn, useWebSession } from '../api/session';
import { useMessagesPanel } from '../messages/panelContext';

/**
 * Sign in with Telegram from a phone page (web-sign-in-checkout D8), as the
 * desktop header's Sign in: the visitor stays on the page they were on. Does
 * nothing until Telegram's window can open.
 */
export function usePhoneSignIn(): () => void {
  const telegram = useTelegramSignIn();
  return () => {
    if (telegram.oneTapReady) telegram.signInOneTap();
  };
}

/**
 * A chat card on a phone page (web-account-pages D8): a signed-in client's opens the
 * messages, with the app's own line under the studio's name; a visitor's starts the sign-in.
 */
export function usePhoneChat(signedInLine: string): { line: string; onChat: () => void } {
  const signedIn = useWebSession().status === 'signedIn';
  const signIn = usePhoneSignIn();
  const { openMessages } = useMessagesPanel();
  return signedIn ? { line: signedInLine, onChat: () => openMessages() } : { line: 'Sign in to send a message', onChat: signIn };
}
